// Dark mode is pure CSS keyed off two classes: body.dark-version (app styles, _dark-version.scss)
// and html.dark (Element Plus dark variables and color-scheme). public/index.html applies them
// before first paint from the saved preference; these toggle them at runtime.

export function activateDarkMode() {
  document.documentElement.classList.add("dark");
  document.body.classList.add("dark-version");
}

export function deactivateDarkMode() {
  document.documentElement.classList.remove("dark");
  document.body.classList.remove("dark-version");
}
